import { type TicketRewardType } from '../types/lottery';

import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';
import diamondTicketPng from '/img/icons/ticket-diamond.png';
import diamondTicketWebp from '/img/icons/ticket-diamond.webp';
import goldTicketPng from '/img/icons/ticket-gold.png';
import goldTicketWebp from '/img/icons/ticket-gold.webp';
import silverTicketPng from '/img/icons/ticket-silver.png';
import silverTicketWebp from '/img/icons/ticket-silver.webp';
import usdtPng from '/img/icons/usdt-green.png';
import usdtWebp from '/img/icons/usdt-green.webp';
import tgemPng from '/img/tgem-big.png';
import tgemWebp from '/img/tgem-big.webp';

const productOfDayRewardsConfig: Record<
  TicketRewardType | 'usdt' | 'tgem' | 'dice',
  { icon: { png: string; webp?: string }; label: string }
> = {
  usdt: {
    icon: { png: usdtPng, webp: usdtWebp },
    label: 'USD',
  },
  tgem: {
    icon: { png: tgemPng, webp: tgemWebp },
    label: 'T-Gem',
  },
  dice: {
    icon: { png: dicePng, webp: diceWebp },
    label: 'Dice',
  },
  silverTicket: {
    icon: { png: silverTicketPng, webp: silverTicketWebp },
    label: 'Silver ticket',
  },
  goldTicket: {
    icon: { png: goldTicketPng, webp: goldTicketWebp },
    label: 'Gold ticket',
  },
  diamondTicket: {
    icon: { png: diamondTicketPng, webp: diamondTicketWebp },
    label: 'Diamond ticket',
  },
};

export { productOfDayRewardsConfig };
